export default __webpack_public_path__ + "static/media/maquina.61385565.png";